<style scoped>
 
/* 状态提示 */
.status-card {
    background: white;
    border-radius: 16px;
    padding: 25px 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    text-align: center;
}

.status-icon {
    font-size: 40px;
    color: #e74c3c;
    margin-bottom: 15px;
}

.status-title {
    font-size: 20px;
    font-weight: 600;
    color: #e74c3c;
    margin-bottom: 10px;
}

.status-desc {
    font-size: 15px;
    color: #666;
}

/* 账单信息 */
.bill-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.bill-item {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f0f0f0;
}

.bill-item:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

.bill-label {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
}

.bill-value {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

.storage-period {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.period-date {
    font-size: 15px;
    color: #333;
}

/* 费用明细 */
.cost-detail {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 15px;
    margin: 15px 0;
}

.cost-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.cost-row:last-child {
    margin-bottom: 0;
}

.cost-label {
    font-size: 15px;
    color: #666;
}

.cost-amount {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

/* 支付区域 */
.payment-section {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    text-align: center;
}

.payment-amount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 10px;
}

.payment-label {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

.payment-value {
    font-size: 20px;
    font-weight: 700;
    color: #e74c3c;
}

.pay-btn {
    background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
    color: white;
    border: none;
    border-radius: 10px;
    padding: 15px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    width: 100%;
    transition: all 0.3s;
}

.pay-btn:hover {
    opacity: 0.9;
    transform: translateY(-2px);
}
</style>

<template>
    <div class="container">

        <div class="status-card">
            <div class="status-icon">
                <i class="fas fa-clock"></i>
            </div>
            <div class="status-title">待支付</div>
            <div class="status-desc">请于15分钟内完成支付</div>
        </div>

        <!-- 账单信息 -->
        <div class="bill-card">
            <div class="bill-item">
                <div class="bill-label">存储编号</div>
                <div class="bill-value">HC202512345-1</div>
            </div>

            <div class="bill-item">
                <div class="bill-label">储存周期</div>
                <div class="storage-period">
                    <div class="period-date">2028.02.15</div>
                    <div class="period-date">至</div>
                    <div class="period-date">2029.02.14</div>
                </div>
            </div>

            <div class="bill-item">
                <div class="bill-label">应付日期</div>
                <div class="bill-value">2025.6.30（当天）</div>
            </div>

            <div class="cost-detail">
                <div class="cost-row">
                    <div class="cost-label">细胞储存费</div>
                    <div class="cost-amount">￥600.00</div>
                </div>
            </div>
        </div>

        <!-- 支付区域 -->
        <div class="payment-section">
            <div class="payment-amount">
                <div class="payment-label">支付：</div>
                <div class="payment-value">￥600</div>
            </div>
            <button class="pay-btn" onclick="handlePayment()">去支付</button>
        </div>
    </div>

</template>

<script>
import router from '../router';

export default {
    name: 'Daizhifu',
    data() {
    return {}},
    methods: {
        handlePayment() {
            // Handle payment logic here
        }
    }
}
</script>